var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ol', {
    staticClass: "breadcrumbs"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: item.text,
      staticClass: "breadcrumb",
      class: {
        'breadcrumb_disabled': _vm.isDisabledItem(item, index)
      }
    }, [_c(_vm.getItemTextComponent(item), {
      tag: "component",
      staticClass: "breadcrumb__text",
      attrs: {
        "href": item.href,
        "to": item.to,
        "tabindex": _vm.isDisabledItem(item, index) ? -1 : undefined
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]), !_vm.isLastItem(index) ? _c('div', {
      staticClass: "breadcrumb__divider"
    }, [_vm._t("divider", function () {
      return [_vm._v(" " + _vm._s(_vm.divider) + " ")];
    })], 2) : _vm._e()], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }